import React from 'react';
import Popover from '../Popover';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './ActivityPopover.css';
import UnreadCommentsData from '../queries/annotations/UnreadCommentsData';
import Store from '../store/Store';
import t from '../i18n/I18n';

export default class ActivityPopover extends React.Component {
  static propTypes = {
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    isNotification: PropTypes.bool
  };

  render() {
    /**
     * @type {UnreadCommentsData}
     */
    const unreadCommentsData = Store.get(UnreadCommentsData.NAME);
    const collectionUnreadCountEntries = unreadCommentsData
      ? unreadCommentsData.getCollectionUnreadCountEntries()
      : undefined;
    const commentCount = _.size(collectionUnreadCountEntries);

    return (
      <Popover {...this.props}>
        <div style={{ width: '120px' }} name="ActivityPopover">
          <div onClick={() => this.onSelect('ALL_ACTIVITY')}>{t('ACTIVITY_POPOVER.ALL_ACTIVITY')}</div>

          <div onClick={() => this.onSelect('TASKS')}>{t('ACTIVITY_POPOVER.TASKS')}</div>

          <div onClick={() => this.onSelect('NOTIFICATIONS')}>{t('ACTIVITY_POPOVER.NOTIFICATIONS')}</div>

          {this.props.isNotification ? (
            <div onClick={() => this.onSelect('COMMENTS')}>
              {t('ACTIVITY_POPOVER.COMMENTS')} <span className="badge">{commentCount}</span>
            </div>
          ) : null}
        </div>
      </Popover>
    );
  }

  onSelect(value) {
    this.props.onSelect(value);
    this.props.onClose();
  }
}
